var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.items,"item-text":_vm.formatCaja,"item-value":"id","label":_vm.label,"loading":_vm.loading,"clearable":_vm.clearable,"outlined":"","dense":""},model:{value:(_vm.item),callback:function ($$v) {_vm.item=$$v},expression:"item"}})
}
var staticRenderFns = []

export { render, staticRenderFns }